import React, { memo } from 'react'
import * as Styled from './styled'

interface IProps {
  labels: string[]
  className?: string
}

const CapabilityChips: React.FC<IProps> = ({ labels, className }) => {
  if (!labels.length) return null

  return (
    <Styled.ChipRow className={className}>
      {labels.map(label => (
        <Styled.Chip key={label}>{label}</Styled.Chip>
      ))}
    </Styled.ChipRow>
  )
}

export default memo(CapabilityChips)
